// /entregas — bandeja del tutor: las entregas de archivos de su proyecto por revisar.
// Entra quien tenga «Es tutor» (Admin → Usuarios) o sea admin; el resto vuelve al inicio.
import React from 'react';
import styled from 'styled-components';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useProject } from '../contexts/ProjectContext';
import BandejaEntregas from '../components/entregas/BandejaEntregas';
import useEntregasPendientes, { esRevisor } from '../components/entregas/useEntregasPendientes';

const Pagina = styled.div`
  background: #f4f7f8; min-height: 100vh;
  padding: clamp(2rem, 4vw, 3rem) 16px 4rem;
  .ancho { max-width: 1200px; margin: 0 auto; }
  h1 { margin: 0; font-size: clamp(1.7rem, 3.5vw, 2.3rem); line-height: 1.15; color: #1f2a37; }
  .sub { margin: .45rem 0 1.6rem; color: #5b6675; line-height: 1.5; max-width: 62ch; }
`;

const EntregasPage = () => {
  const { user } = useAuth();
  const { proyecto } = useProject();
  const { pendientes } = useEntregasPendientes(user);
  if (user && !esRevisor(user)) return <Navigate to="/" replace />;
  const cfg = proyecto?.config_json?.entregas || {};
  return (
    <Pagina>
      <div className="ancho">
        <h1>{cfg.titulo_bandeja || 'Entregas por revisar'}{pendientes > 0 ? ` (${pendientes})` : ''}</h1>
        <p className="sub">{cfg.texto_bandeja || 'Descarga lo que enviaron tus alumnos, califícalo y apruébalo o devuélvelo con un comentario. Al abrir una entrega queda a tu nombre para que otro tutor no la califique a la vez.'}</p>
        <BandejaEntregas acento={cfg.color || proyecto?.color_primario || undefined} />
      </div>
    </Pagina>
  );
};

export default EntregasPage;
